/// <reference path="../../meevoMessenger.module.ts" />

module Meevo.Plugins.MeevoMessenger {

    import IDataMaintenanceInfiniteList = Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    class UndeleteConversationModalController {
        static $inject = [
            'onUndeleteCallback',
            'pointSummary',
            'type',
            'userHasAccessToViewPhoneNumber',
            '$mdDialog',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.plugins.meevoMessenger.meevoMessengerService',
            'meevo.plugins.meevoMessenger.meevoMessengerApiService',
            'meevo.components.busy.BusyService'
        ];

        constructor(
            onUndeleteCallback: Function,
            pointSummary: string,
            type: UndeleteConversationTypesEnum,
            userHasAccessToViewPhoneNumber: boolean,
            protected $mdDialog: angular.material.IDialogService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected meevoMessengerService: IMeevoMessengerService,
            protected meevoMessengerApiService: IMeevoMessengerApiService,
            protected busyService: Meevo.Components.Busy.BusyService,
        ) {
            this.type = type;
            this.pointSummary = pointSummary;
            this.onUndeleteConversationCallback = onUndeleteCallback;
            this.userHasAccessToViewPhoneNumber = userHasAccessToViewPhoneNumber;
        }

        public onUndeleteConversationCallback: Function;
        public pointSummary: string;
        public type: UndeleteConversationTypesEnum;
        public userHasAccessToViewPhoneNumber: boolean;
        private selectedConversation: MeevoMessengerConversation;
        private undeleteCallbackOpt: IUndeleteConversationOptions = { isClientConversation: true };

        undelete() {
            this.busyService.start();
            this.meevoMessengerApiService.undeleteConversation(this.selectedConversation).then((undeleteConversationInfo: MeevoMessengerConversation) => {
                if (angular.isDefined(this.onUndeleteConversationCallback)) {
                    this.selectedConversation.phoneNumber = undeleteConversationInfo.phoneNumber;
                    // lastMessageIsRead is false by default and it shoud be changed to true
                    this.onUndeleteConversationCallback(
                        {
                            ...this.selectedConversation,
                            ...{
                                entityVersion: undeleteConversationInfo.entityVersion,
                                lastMessage: {
                                    ...undeleteConversationInfo.lastMessage,
                                    isRead: true,
                                },
                                objectState: ObjectStateEnum.Active
                            }
                        },
                        this.undeleteCallbackOpt,
                    );
                }
                this.close();
            }).finally(() => this.busyService.stop());
        }

        close() {
            this.$mdDialog.hide();
        }

        private get isDisabledUndeleteButton(): boolean {
            return angular.isUndefined(this.selectedConversation);
        }

        private get typesEnum() {
            return UndeleteConversationTypesEnum;
        }
    }

    angular.module('meevo.plugins.meevoMessenger')
        .controller('meevo.plugins.meevoMessenger.modals.UndeleteConversationModalController', UndeleteConversationModalController);
}
